import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { useEffect, useState } from "react";
import { VStack } from "@/components/layout/VStack";
import { Students } from "@/artifacts/admin/components/dashboard/Students/Students";
import { ManageStudentSheet } from "@/artifacts/admin/components/dashboard/ManageStudent/ManageStudentSheet";
import { useLoadDashboard } from "@/artifacts/admin/hooks/dashboard/useLoadDashboard";
import type { StudentsData } from "@/artifacts/admin/pages/Dashboard";

const Advisees = () => {
  const [advisees, setAdvisees] = useState<StudentsData[] | null>(null);
  const [sessionsData, setSessionsData] = useState<{
    rotations: any[];
    sessions: any[];
  } | null>(null);
  const [teachers, setTeachers] = useState<any[] | null>(null);
  const [manageOpen, setManageOpen] = useState<{
    open: boolean;
    student: any;
  }>({
    open: false,
    student: undefined,
  });

  const { loadStudents, loadSessionsData, loadTeachers, loading } =
    useLoadDashboard({ apiBase: "advisor" });

  useEffect(() => {
    loadStudents(setAdvisees);
  }, []);

  useEffect(() => {
    if (manageOpen.open && !sessionsData) {
      loadSessionsData(setSessionsData);
    }
  }, [manageOpen, sessionsData]);

  useEffect(() => {
    if (manageOpen.open && !teachers) {
      loadTeachers(setTeachers);
    }
  }, [manageOpen, teachers]);

  const onOpen = (studentId: string) => {
    const student = advisees?.find((s) => s._id === studentId);
    setManageOpen({ open: true, student });
  };

  return (
    <Dashboard activePage="/advisees">
      <VStack>
        <h2
          style={{
            fontSize: "var(--text-2xl)",
            lineHeight: "var(--line-height-2xl)",
            fontWeight: "var(--font-bold)",
          }}
        >
          Advisees
        </h2>
        <p style={{ color: "var(--muted-foreground)" }}>
          View and manage enrollments and preferences for your advisees.
        </p>
      </VStack>
      <Students data={advisees} loading={loading.students} onOpen={onOpen} />
      {manageOpen.student && (
        <ManageStudentSheet
          student={manageOpen.student}
          open={manageOpen.open}
          onOpenChange={(open) => {
            setManageOpen((prev) => ({
              open,
              student: prev.student,
            }));
          }}
          sessionsData={sessionsData}
          teachers={teachers}
          loading={loading.sessionsData}
          apiBase="advisor"
        />
      )}
    </Dashboard>
  );
};

export default Advisees;
